import { gql } from '@apollo/client';


export const GET_INVOICES_FOR_PAYMENT_INTENT = gql`
  query getInvoicesInPaymentIntent($where: StripePaymentIntentWhereUniqueInput!) {
    findUniqueStripePaymentIntent(where: $where) {
      id
      invoices {
        id
        identifier
        createdAt
        date
      }
    }
  }
`;

export const GET_SINGLE_INVOICE = gql`
  query getSingleInvoiceWithLineItems($where: InvoiceWhereUniqueInput!, $clinicPetParentId: String) {
    getInvoiceById(where: $where) {
      id
      description
      createdAt
      identifier
      status
      date
      total
      taxes
      subtotal
      outstandingBalance
      currency
      sentBy {
        nameDisplay
      }
      relatedInvoiceWritebacks {
        writebackLogId
        writebackLog {
          id
          requestBody
        }
        action
      }
      lineItems(
        orderBy: { lineNumber: asc }
        where: { isDeleted: { equals: false }, isHidden: { equals: false }, isVoided: { equals: false } }
      ) {
        id
        lineNumber
        type
        serviceId
        amount
        fee
        discount
        quantity
        description
        connectedCareBenefits {
          id
          adjustedAmount
          careBenefitUsage {
            id
            benefitId
            reason
            quantityUsed
          }
        }
        clinicPets {
          id
          pimsId
          name
          species
          speciesType
          weight
          organizationPetId
          organizationPet {
            id
            carePlanEnrollments(where: { status: { equals: Active } }) {
              planId
            }
          }
        }
        service {
          id
          name
          code
          pimsName
          organizationCareBenefitToClinicService {
            benefit {
              id
              title
              description
              tangible
              providedDiscountPercentage
              usageUnitOfMeasure
              planBenefits {
                id
                includedUses
              }
            }
          }
          draftCareBenefitUsageToInvoiceLineItems(
            where: {
              careBenefitUsage: { usageClinicPet: { petParents: { some: { id: { equals: $clinicPetParentId } } } } }
              invoiceLineItemId: { equals: null }
            }
          ) {
            id
            adjustedAmount
            careBenefitUsage {
              id
              usageClinicPetId
              benefit {
                id
                title
                usageUnitOfMeasure
                providedDiscountPercentage
              }
              usedAt
              quantityUsed
            }
            invoiceLineItemId
          }
        }
        provider {
          id
          firstName
          lastName
        }
        connectedCareBenefits {
          id
          adjustedAmount
          careBenefitUsage {
            id
            usedAt
            reason
            usageClinic {
              id
              name
            }
            recordedByUser {
              id
              firstName
              lastName
            }
            benefit {
              id
              title
              description
              tangible
              providedDiscountPercentage
            }
            usageClinicPetId
          }
        }
      }
      pimsInvoice {
        invoiceId
        pimsId
      }
      clinicPetParent {
        clinic {
          name
          id
          customerId
          addressLine1
          addressLine2
          city
          state
          postalCode
          fullAddress
          phone
          clinicEmail
          websiteUrl
          logo
        }
        id
        pimsId
        firstName
        lastName
        email
        phoneNumber
        pets {
          id
          name
        }
      }
      stripePaymentIntents(orderBy: { createdAt: desc }, take: 1) {
        id
        clientServiceFeePercent
        clientServiceFee
        serviceFeeAmount
        status
        createdAt
        amount
        amountCaptured
        stripeReceipt {
          id
          applicationName
          dedicatedFileName
          accountType
        }
      }
    }
  }
`;

export const GET_FORM_PDF = gql`
  query getFormPdf($formId: String!) {
    formSubmissionExport(where: { id: $formId }) {
      fileType
      base64Encoding
    }
  }
`;
